import { inject, Injectable } from '@angular/core';
import { InjectableSuperclass } from '@sama/ng-core';
import { debounceOnMicroQueue } from '../../../shared/misc-utilities/misc-utils';
import { ContentConnector } from '../../../team-apis/content/content-connector';
import { TaskWorkspaceStore } from '../../h3ml/state/task-workspace-store';
import { AnnotationColorUpdateService } from './annotation-color-update.service';
import { AnnotationFilterUpdateService } from './annotation-filter-update.service';

@Injectable()
export class AnnotationTransientInfoService extends InjectableSuperclass {
  private taskWorkspaceStore = inject(TaskWorkspaceStore);
  private annotationFilterUpdateService = inject(AnnotationFilterUpdateService);
  private annotationColorUpdateService = inject(AnnotationColorUpdateService);

  subscribeToChangesUpdatingTransientInfo() {
    this.annotationFilterUpdateService.subscribeToChangesUpdatingFiltering();
    this.annotationColorUpdateService.subscribeToChangesUpdatingColor();
  }

  setUpShapeTransientInfoContentSynchronization(
    contentConnector: ContentConnector,
  ) {
    this.subscribeTo(
      this.taskWorkspaceStore('shapeTransientInfo').$.pipe(
        debounceOnMicroQueue(),
      ),
      (shapeTransientInfo) => {
        contentConnector.setShapeTransientInfo(shapeTransientInfo);
      },
    );
  }

  syncContentScopedObjectId(contentConnector: ContentConnector) {
    this.subscribeTo(
      this.taskWorkspaceStore('scopedObjectId').$,
      (scopedObjectId) => {
        contentConnector.updateShapeCreationEnabled(scopedObjectId);
      },
    );
  }
}
